import React from 'react';

const SvgAbstract42 = ({ svgRef, title, ...props }) => (
  <svg viewBox="0 0 18 18" ref={svgRef}  {...{ ...{ width: '1em', height: '1em' }, ...props }}>
    <title>{title}</title>
    <path d="M10.29.29l6.83 6.83A3 3 0 0 1 18 9.24V17a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-5.75a.25.25 0 0 0-.25-.25h-3.5a.25.25 0 0 0-.25.25V17a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V9.24a3 3 0 0 1 .88-2.12L7.71.29a1 1 0 0 1 .7-.29h1.18a1 1 0 0 1 .7.29zM9.17 2h-.34L2.29 8.54a1 1 0 0 0-.29.7V16h3v-6a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6h3V9.24a1 1 0 0 0-.29-.7z" fill="currentColor" />
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => <SvgAbstract42 svgRef={ref} {...props} />);
export default ForwardRef;
